export const servicecolumns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '任务名称',
    dataIndex: 'title',
  },
  {
    title: '关联产品',
    dataIndex: 'chanpin',
  },
  {
    title: '开始时间',
    dataIndex: 'plan_start_time',
  },
  {
    title: '结束时间',
    dataIndex: 'plan_end_time',
  },
  {
    title: '发起方',
    dataIndex: 'qichacha_name',
  },
  {
    title: '任务总额',
    dataIndex: 'work_plan_budget',
  },
  {
    title: '服务省份',
    dataIndex: 'province',
  },
  {
    title: '审核状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
export const yaoqicolumns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '任务名称',
    dataIndex: 'title',
  },
  {
    title: '关联产品',
    dataIndex: 'chanpin',
  },
  {
    title: '开始时间',
    dataIndex: 'plan_start_time',
  },
  {
    title: '结束日期',
    dataIndex: 'plan_end_time',
  },
  {
    title: '执行方',
    dataIndex: 'qichacha_name',
  },
  {
    title: '任务总额',
    dataIndex: 'work_plan_budget',
  },
  {
    title: '服务省份',
    dataIndex: 'province',
  },
  {
    title: '审核状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
export const formData1 = [
  {
    name: 'name',
    lable: '执行方',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },

  {
    name: 'agreement_id',
    lable: '推广计划',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'company',
    lable: '发起方',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'taxscale',
    lable: '发票金额',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'province_city',
    lable: '推广区域',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'budget',
    lable: '推广预算',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },

  {
    name: 'title',
    lable: '任务名称',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'plan_time',
    lable: '任务期限',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'materials_cost',
    lable: '物料费',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
];
export const formData2 = [
  {
    name: 'name',
    lable: '',
    lableCol: 0,
    wrapperCol: 24,
    offset: 0,
    span: 24,
  },
];
export const formData3=[
  {
    name: 'flag',
    lable: '是否同意',
    lableCol: 3,
    wrapperCol: 10,
    offset: 0,
    span: 24,
  },
  {
    name: 'desc',
    lable: '',
    lableCol: 3,
    wrapperCol: 10,
    offset: 3,
    span: 24,
  },
];
export const columns1 = [
  {
    title: '推广项目',
    width: 180,
    dataIndex: 'name',
  },
  {
    title: '预算金额(元/次)',
    width: 130,
    dataIndex: 'budget',
  },
  {
    title: '任务数量(次)',
    dataIndex: 'plan_num',
    width: 100,
    scopedSlots: { customRender: 'plan_num' },
  },
  {
    title: '任务金额(元)',
    dataIndex: 'amount',
    width: 130,
    scopedSlots: { customRender: 'amount' },
  },
  {
    title: '关联产品',
    dataIndex: 'related_product',
    width: 180,
    scopedSlots: { customRender: 'related_product' },
  },
  {
    title: '关联资料',
    dataIndex: 'related_informations',
    width: 200,
    scopedSlots: { customRender: 'related_informations' },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: 150,
    scopedSlots: { customRender: 'operation' },
  },
];
